import { Page } from '@bonanza-social/navigation';
import ProviderGames from '../components/ProviderGames/ProviderGames';
import { Navigate, useSearchParams } from 'react-router';
import useGames from '../hooks/useGames';

function ProviderGamesPage() {
  const [params] = useSearchParams();
  const subProviderName = params.get('subProviderName');

  useGames();

  if (!subProviderName) {
    return <Navigate to="/games" replace />;
  }

  return (
    <Page>
      <ProviderGames provider={subProviderName} />
    </Page>
  );
}

export default ProviderGamesPage;
